import { render, staticRenderFns } from "./host-introduction.vue?vue&type=template&id=10aa81b3&scoped=true&"
import script from "./host-introduction.vue?vue&type=script&lang=js&"
export * from "./host-introduction.vue?vue&type=script&lang=js&"
import style0 from "./host-introduction.vue?vue&type=style&index=0&id=10aa81b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa81b3",
  null
  
)

export default component.exports